module.exports = __webpack_public_path__ + "img/new-guide-00-3.e4e601a5.png";